export default {
    movies: []
}